<app-website-header></app-website-header>
<div class="header">
  <img src="\assets\images\contact_us.jpg" class="background-banner" alt="Contact Us Header Image"/>
</div>
<div class="container">
  <div class="t d-flex justify-content-center ">
    <div class="t-img"></div>
    <div class="d-flex flex-column lm align-items-center p-3 contactusStorybox">
      <p class="d-flex justify-content-center heading mainheading">Our Story Begins</p>
      <p class="contactusStoryDescription">At Medworld Expo, we embarked on a journey to redefine how medical equipment is showcased and traded in the digital age. What began as a vision to bridge the gap between healthcare providers and manufacturers has evolved into a global platform that empowers industry professionals to connect, collaborate, and innovate. </p>
      <button class="button button-primary px-2 learn-more" routerLink="/aboutus">Learn More</button>
    </div>
  </div>

  <div class="d-flex justify-content-around flex-wrap contact-us-fields" style="margin-top: 29px; display: -webkit-flex;">
    <div class="ml" >
      <form [formGroup]="contactUs" class="d-flex flex-column contactUs-form">
        <h1  style="margin: 0;" class="heading enquiry-heading">Get in touch today</h1><br>
        <mat-form-field appearance="outline" class="input-font">
          <input matInput formControlName="name" placeholder="Your Name" class="input-field">
          <mat-error class="error-message error-msg" *ngIf="!contactUs.get('name')?.valid">
            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Name is Required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-font">
          <input matInput formControlName="email" placeholder="Email Address" type="email" class="input-field">
          <mat-error class="error-message error-msg" *ngIf="!contactUs.get('email')?.valid">
            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Email Address is Required
          </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" class="input-font">
          <input matInput formControlName="phoneNumber" placeholder="Phone Number" type="tel" onlyNumbers class="input-field">
          <mat-error class="error-message error-msg" *ngIf="!contactUs.get('phone')?.valid">
            <img class="error-icon" loading="lazy" alt="" src="./../../assets/images/alert.svg" /> Phone Number is Required
          </mat-error>
        </mat-form-field>
        
        
            <textarea matInput class="textarea input-field" formControlName="message" placeholder="Message"></textarea>
        <div class="Submit-Button">
        <button class="button button-primary send-message-button" (click)="sendMessage()" >Submit Enquiry</button>
        </div>
      </form>
      <div style="display: flex; align-items: flex-end; gap: 15px; margin-top: 25px;" class="social-media">
        <div style="position: relative;top: 2px;" class="connect-with-us">Connect With Us:</div>
        <div class="social-media-links">
          <a class="link" href="https://www.facebook.com/profile.php?id=61566439358533" target="_blank" rel="noopener noreferrer"><img src="../../../../assets/images/account_type/Facebook App Symbol.svg" style="cursor: pointer;"  alt="f" class="social-media-imgs"></a>
          <a class="link" href="https://x.com/Medworld_Expo" target="_blank" rel="noopener noreferrer"><img src="../../../../assets/images/account_type/Twitter.svg" style="cursor: pointer;" alt="f" class="social-media-imgs"></a>
          <a class="link" href="https://www.linkedin.com/in/medworld-expo-407343330/" target="_blank" rel="noopener noreferrer"><img src="../../../../assets/images/account_type/Linkedin Big Logo.svg" style="cursor: pointer;" alt="f" class="social-media-imgs"></a>
          <a class="link" href="https://www.youtube.com/@MedworldExpo" target="_blank" rel="noopener noreferrer"><img src="../../../../assets/images/account_type/Youtube.svg" style="cursor: pointer;" alt="f" class="social-media-imgs"></a>
          <a class="link" href="https://www.instagram.com/medworld_expo/" target="_blank" rel="noopener noreferrer"><img src="../../../../assets/images/account_type/Instagram.svg" alt="InstagramImg" style="cursor: pointer;" class="social-media-imgs"></a>
        </div>
      </div>
    </div>
    <div class="contact-us-image" style="margin-top: 9px; max-width: 400px;">
      <div class="card d-flex flex-column justify-content-left" >
        <div class="card-img ">
          <img src="\assets\images\contactusimg.jpg"  class="card-img-top" alt="company logo">
        </div>
        <div class="card-info d-flex flex-column justify-content-start" style="margin-left: 40px; position: relative;top: -20px;">
          <div class="row address" style="width:380px;">
            
            <div class="d-flex flex-row gap-3" style="max-width: 350px; margin-left: -5px;">
              <div class=" my-2 icon-img"><img src="../../assets/images/icons/building-office-productpage.svg" class="star"></div>
              <p class=" my-2 card-info-details">ExpoUniverse Private Limited</p></div>

           <div class="d-flex flex-row gap-3" style="max-width: 350px; margin-left: -5px;">
            <div class=" my-2 icon-img"><img src="../../assets/images/icons/location-icon-productpage.svg" class="star"></div>
            <p style="text-align: left;" class="card-info-details">
              1-55/193/D2, CMC Layout, Kondapur, Hyderabad - 500084, Telangana, INDIA</p></div>

            <div class="d-flex flex-row gap-3" style="margin-left: -2px; cursor: pointer;" (click)="openWhatsapp()">
            <div class=" my-2 icon-img"><img  src="../../assets/images/icons/whatsapp-icon.svg" class="star" width="16px" ></div>
            <p class=" my-2 card-info-details" style="color: #0D87C8;" >(+91) 9059013838</p></div>
           
            <div class="d-flex flex-row gap-3" style="margin-left: -2px; cursor: pointer;" (click)="openGmail()">
            <div class=" my-2 icon-img"><img src="../../assets/images/icons/gmail-icon-logo-contactUs.svg" class="star" width="16px"></div>
            <p class=" my-2 card-info-details" style="color: #0D87C8;">{{contactEmail}}</p></div>
        
        </div>
      </div>
    </div>
  </div>
</div>

 
    <div class="mapouter">
      <div class="gmap_canvas">
        <!-- <iframe width="100%" height="500" id="gmap_canvas" src="https://maps.google.com/maps?q=Endeavour%20Technologies,%20Kondapur,%20Hyderabad,%20Telangana%2C%20India&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe> -->
        <iframe id="gmap_canvas" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3805.963080169303!2d78.34293327573971!3d17.461481100665292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb93d816a8a141%3A0x1b034f8ec8f5a087!2sExpoUniverse%20Private%20Limited!5e0!3m2!1sen!2sin!4v1728382424196!5m2!1sen!2sin"
        frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
      </div>
    </div>
 

  <div class="FAQ d-flex flex-column align-items-center " style="margin-bottom:29px;">
    <p class="heading-faq">Frequently Asked Questions</p>
  
    <div class="questions">
      <hr class="line d-md-none d-lg-none" >
      <ul *ngFor="let question of faq; let i = index" class="main-question">
        <li class="d-flex justify-content-between align-items-center question-box" >
          <div class="q" style="margin-bottom:5px;">
            {{ question.question  }}
          </div>
          <div class="arrow-down">
            <img
              [src]="selectedIndex === i ? '/assets/images/dropdown-up-arrow.svg' : '/assets/images/icons/down-chevron_9144316.svg'"
              height="15px"
              width="15px"
              style="cursor: pointer;"
              (click)="showAnswer(i)"
            >
          </div>
        </li>
        
        <p class="answer" *ngIf="question.display">
          {{question.answer}}
        </p>
        <hr class="line d-md-none d-lg-none">
      </ul>
    </div>
  </div>

</div>
<app-website-footer></app-website-footer>